<ng-container *ngIf="menu && entity">
  <div class="row">
    <div *ngIf="menu?.sections?.length" class="col-sm-5">
      <div class="sections d-flex flex-column">
        <div class="section d-flex align-items-center mb-2 w-100 p-3" [ngClass]="{ 'border-primary' : sectionTitle === section.title && !colourScheme?.primary }" *ngFor="let section of menu.sections" (click)="toggleSection(section)"
        [style.border-color]="sectionTitle === section.title ? primaryColourText || '' : secondaryColourText || ''"
        [style.background]="sectionTitle === section.title ? colourScheme?.primary || '' : colourScheme?.secondary || ''"
        [style.color]="sectionTitle === section.title ? primaryColourText || '' : secondaryColourText || ''"
        >
            <fa-icon size="2x" class="mr-3"
            [ngClass]="{ 'text-primary' : sectionTitle === section.title && !colourScheme?.primary }"
            [style.color]="sectionTitle === section.title ? primaryColourText || '' : secondaryColourText || ''"
            *ngIf="section.icon; else noIcon"
            [icon]="convertIcon(section.icon[1])"></fa-icon>
            <ng-template #noIcon>
              <fa-icon size="2x" class="mr-3"
              [ngClass]="{ 'text-primary' : sectionTitle === section.title && !colourScheme?.primary }"
              [style.color]="sectionTitle === section.title ? primaryColourText || '' : secondaryColourText || ''"
              [icon]="icons['book']"></fa-icon>
            </ng-template>
          <p class="font-weight-bold my-0 text-uppercase"
          [ngClass]="{ 'text-primary' : sectionTitle === section.title && !colourScheme?.primary }"
          [style.color]="sectionTitle === section.title ? primaryColourText || '' : secondaryColourText || ''"
          >
            {{ section.title | titlecase }}</p>
        </div>
      </div>
    </div>
    <div *ngIf="currentSection" class="col-sm-7 mt-3 mt-sm-0">
      <!-- <h4 class="desktop-hide mb-2" *ngIf="currentSection.title">{{currentSection.title}}</h4> -->
      <p class="my-2" *ngIf="currentSection?.description">
        {{ currentSection.description }}</p>
      <div class="menu-wrapper" *ngIf="currentSection?.items?.length; else empty">
        <div class="d-flex justify-content-between align-items-center py-2" [ngClass]="{'border-bottom' : i !== currentSection?.items?.length - 1}" *ngFor="let item of currentSection.items; let i = index"
          (click)="openItemModal(item)">
          <div class="d-flex flex-grow-1">
            <div class="item-img rounded-circle d-flex flex-center placeholder mr-3" *ngIf="item.image">
              <img-fade class="cover-img" [animate]="true" [src]="imageurl + item.image" alt="{{item?.title}} menu item"></img-fade>
            </div>
            <div class="d-flex flex-column pr-2">
                <p class="font-weight-bold mb-1">{{ item.title }}</p>
                <p class="text-medium mb-0 small" style="font-weight: 400" *ngIf="item?.description">{{ item.description }}</p>
            </div>
          </div>
          <div class="d-flex text-right">
            <span [ngClass]="{'crossed-out': item.offerPrice }">{{ item.price | currency:entity?.currency?.symbol }}</span>
            <span class="text-primary ml-1" *ngIf="item.offerPrice">{{  item.offerPrice | currency:entity?.currency?.symbol }}</span>
          </div>
        </div>
      </div>

      <ng-template #empty>
        <div class="d-flex flex-grow-1 flex-center pt-5">
          <p>There are currently no items listed under this menu section</p>
        </div>
      </ng-template>

    </div>
  </div>

</ng-container>
